import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import Header from 'components/Header';
import Footer from 'components/Footer';
import LoadingDialog from 'components/global/LoadingDialog';

import { getPageList, getPageAllList } from 'context/actions/pages';
import { SET_USER_MENUS, SET_FOOTER_MENUS, SET_ALL_PAGES } from 'context/actions/system';

export default function MainLayout({ children }) {
    const system = useSelector((state) => state.system);
    const dispatch = useDispatch();

    // Mount-д header + footer + бүх pages dynamic хуудсуудыг татаж redux-д хадгална
    useEffect(() => {
        (async () => {
            const headerRes = await getPageList(true);
            if (headerRes?.status === 'success' || headerRes?.code === 200) {
                dispatch({ type: SET_USER_MENUS, data: headerRes.data });
            }

            const footerRes = await getPageList(false);
            if (footerRes?.status === 'success' || footerRes?.code === 200) {
                dispatch({ type: SET_FOOTER_MENUS, data: footerRes.data });
            }

            // Бүх pages-ыг flat listээр татаж cache-лэнэ
            // Public хуудсууд (teachers, news, clubs, topik, contact) үүнээс
            // өөрийн URL-тай тохирох бичлэгийн cover + title-ыг авна.
            const allRes = await getPageAllList();
            if (allRes?.status === 'success' || allRes?.code === 200) {
                dispatch({ type: SET_ALL_PAGES, data: allRes.data });
            }
        })();
    }, [dispatch]);

    return (
        <>
            <Header />
            <main className="min-h-screen">{children}</main>
            <Footer />

            {system.showLoading && <LoadingDialog open={system.showLoading} />}
        </>
    );
}
